<script>
import Titre from "@/components/atoms/titre";
import LazyImage from "@/components/atoms/lazy-image";
import AbonnementItem from "@/containers/fiche-abonnement/abonnementItem";
import AbonnementLadVignetteAbonne from "@/components/organisms/abonnement-lad/vignette-abonne";
import Container from "@/components/atoms/container";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import Divider from "@/components/atoms/divider";
import Badge from "@/components/atoms/badge";
import Breadcrumbs from "@/components/molecules/breadcrumbs/default";
import Popin from "@/containers/popin-adaptive";
import CmsFetcher from "@/containers/cms-fetcher";
import PlanningCommunesSelector from "@/containers/planning/planning-communes-selector";
import Planning from "@/containers/planning";
import { getOffset } from "@/utils/focus";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import { usePageMerchAboLad } from "../mixins/merch-abo-lad";

import illuAbonnementTransat from "@/assets/images/abonnement/fiche/svg/illu-abonnement-transat.svg";
import livraisonCcmStep4 from "@/assets/images/abonnement/fiche/svg/livraison-ccm-step4.svg";
import livraisonCcmStep3 from "@/assets/images/abonnement/fiche/svg/livraison-ccm-step3.svg";
import livraisonCcmStep2 from "@/assets/images/abonnement/fiche/svg/livraison-ccm-step2.svg";
import livraisonCcmStep1 from "@/assets/images/abonnement/fiche/svg/livraison-ccm-step1.svg";
import livraisonSereine from "@/assets/images/abonnement/animations/livraison-sereine.gif";
import coraplusLogo from "@/assets/images/abonnement/coraplus/coraplus-logo.svg";
import abonnementLivraisonCoraHeader from "@/assets/images/abonnement/fiche/png/abonnement-livraison-cora-header.png";

export default {
  name: "FicheAbonnement",
  components: {
    Titre,
    LazyImage,
    AbonnementLadVignetteAbonne,
    AbonnementItem,
    Container,
    Button,
    Divider,
    Badge,
    ButtonIcon,
    Breadcrumbs,
    Popin,
    CmsFetcher,
    PlanningCommunesSelector,
    Planning,
    HtmlParser
  },
  props: {
    displayMode: {
      type: String,
      required: false,
      default: null
    },
    abonnements: {
      type: Array,
      required: true
    },
    clientAbonnements: {
      type: Array,
      required: false,
      default: () => {
        return null;
      }
    },
    aboLadMaxAtteint: {
      type: Boolean,
      required: false,
      default: false
    },
    minimumLad: {
      type: Number,
      required: false,
      default: null
    },
    magasin: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    isNational: {
      type: Boolean,
      required: false,
      default: true
    },
    shopName: {
      type: String,
      required: false,
      default: ""
    },
    serviceLadId: {
      type: Number,
      required: true
    }
  },
  emits: ["openOrcloseStoreLocator"],
  setup() {
    const { aboladcodes, getAboLadData, merchAboLad } = usePageMerchAboLad();
    return {
      aboladcodes,
      getAboLadData,
      merchAboLad,
      illuAbonnementTransat,
      livraisonCcmStep4,
      livraisonCcmStep3,
      livraisonCcmStep2,
      livraisonCcmStep1,
      livraisonSereine,
      coraplusLogo,
      abonnementLivraisonCoraHeader
    };
  },
  computed: {
    isAbonneInMagasin() {
      if (this.aboLadMaxAtteint) {
        return true;
      }
      if (this.clientAbonnements && this.clientAbonnements.length > 0) {
        for (const abonnement of this.clientAbonnements) {
          if (parseInt(this.magasin.id) === abonnement.attributes.magasin_id) {
            return true;
          }
        }
        return false;
      }
      return false;
    }
  },
  methods: {
    scrollToAbonnements() {
      const abonnementsElement = this.$el.querySelector("#abonnements-section");
      const top = getOffset(abonnementsElement).top;
      window.scrollTo(0, top - 100);
    },
    setPopinCgvVisible(visible) {
      this.popinCgvVisible = visible;
    },
    setPopinZoneVisible(visible) {
      this.popinZoneVisible = visible;
    },
    back() {
      this.$router.back();
    },
    communeSelected(commune) {
      this.commune = commune;
    }
  },
  data() {
    return {
      breadcrumbs: [{ text: "Livraison à domicile", route: { link: "#" } }],
      popinCgvVisible: false,
      popinZoneVisible: false,
      commune: null
    };
  }
};
</script>
<template>
  <div class="u-bgcolor-white">
    <div class="c-abonnement-lad-fiche">
      <Breadcrumbs
        v-if="displayMode !== 'appli'"
        :breadcrumbs="breadcrumbs"
        class="u-mr-sm u-ml-sm"
      />
      <Container v-if="displayMode !== 'appli'">
        <ButtonIcon
          icon-name="arrow-left"
          icon-color="text"
          icon-color-hover="primary-light"
          text-hover-color="primary-light"
          class="u-mt-sm"
          size="xs"
          @click="back()"
        >
          Retour
        </ButtonIcon>
      </Container>

      <div
        v-if="!isAbonneInMagasin"
        class="c-abonnement-lad-fiche-header"
      >
        <div class="c-abonnement-lad-fiche-header__content">
          <div>
            <client-only v-if="getAboLadData(aboladcodes.URL_IMAGE)">
              <LazyImage
                :src=" getAboLadData(aboladcodes.URL_IMAGE)"
                width="574"
                height="356"
                alt="Apres le plein de courses du mois, on invente le plein de courses du jour."
                class="c-abonnement-lad-fiche-header__visuel"
              />
            </client-only>
            <LazyImage
              v-else
              :src="abonnementLivraisonCoraHeader"
              width="574"
              height="356"
              alt="Apres le plein de courses du mois, on invente le plein de courses du jour."
              class="c-abonnement-lad-fiche-header__visuel"
            />
            <div class="c-abonnement-lad-fiche-header__info">
              <LazyImage
                :src="coraplusLogo"
                height="80"
                alt="Coraplus"
                class="c-abonnement-lad-fiche-header__logo"
              />
              <client-only v-if="getAboLadData(aboladcodes.DESCRIPTION)">
                <HtmlParser
                  class="c-abonnement-lad-fiche-header__info_merch"
                  :content="getAboLadData(aboladcodes.DESCRIPTION)"
                />
              </client-only>
              <p v-else>
                Faites-vous livrer tous les jours si vous le voulez*
              </p>
            </div>
          </div>
          <client-only v-if="getAboLadData(aboladcodes.MENTION_LEGALE)">
            <div>
              {{ getAboLadData(aboladcodes.MENTION_LEGALE) }}
            </div>
          </client-only>
          <p v-else>
            *Sous réserve d'un créneau de livraison disponible ainsi qu'à l'exception des dimanches et jours fériés.
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="isAbonneInMagasin"
      class="c-abonnement-lad-fiche__header--suscribed"
    >
      <div class="c-abonnement-lad-fiche__header-content">
        <div class="c-abonnement-lad-fiche__header-title">
          <LazyImage
            :src="coraplusLogo"
            width="163"
            height="40"
            alt="Coraplus"
          />
        </div>
        <div class="c-abonnement-lad-fiche__header-encart-wrapper">
          <AbonnementLadVignetteAbonne
            :abonnements="clientAbonnements"
            :max-abo-reached="aboLadMaxAtteint"
            class="c-abonnement-lad-fiche__header-encart u-mx-auto"
            @openStoreLocator="$emit('openOrcloseStoreLocator')"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="c-abonnement-lad-vignette-section"
    >
      <client-only>
        <HtmlParser
          v-if="getAboLadData(aboladcodes.DESCRIPTION_OFFRE_HTML)"
          :content="getAboLadData(aboladcodes.DESCRIPTION_OFFRE_HTML)"
          class="u-mb-md"
        />
      </client-only>
      <div
        id="abonnements-section"
        class="u-flex u-flex-justify-center"
      >
        <div class="c-abonnement-lad-vignette-wrapper">
          <Titre
            tag="h2"
            variant="primary"
            size="lg"
            class="u-text-center u-mb-lg u-mb-md@md"
          >
            {{ abonnements.length }} formules pour répondre à vos besoins
          </Titre>
          <client-only>
            <div v-if="abonnements && abonnements.length > 0">
              <AbonnementItem
                v-for="abonnement in abonnements"
                :key="abonnement.id"
                :abonnement="abonnement"
                class="u-mx-xs u-mb-lg"
              />
            </div>
          </client-only>
        </div>
      </div>
      <div class="u-text-center">
        <Button
          link
          @click="setPopinCgvVisible(true)"
        >
          Voir les conditions de l'offre
        </Button>
      </div>
      <div
        v-if="!isNational"
        class="u-text-center u-pt-sm"
      >
        <Button
          link
          @click="setPopinZoneVisible(true)"
        >
          Voir les zones de livraison éligibles
        </Button>
      </div>
    </div>

    <div class="u-bgcolor-white u-pt-lg30">
      <div class="c-abonnement-lad-fiche__advantage">
        <Titre
          tag="h2"
          variant="primary"
          size="lg"
          class="u-text-center"
        >
          Vos livraisons l'esprit tranquille
        </Titre>
        <div>
          <div>
            <LazyImage
              :src="livraisonSereine"
              width="400"
              height="400"
              alt=""
            />
            <ul class="c-abonnement-lad-fiche__advantage-list">
              <li>Vos livraisons en illimité *</li>
              <li>La liberté de choisir la formule qui correspond à vos besoins</li>
              <li>Payer en une seule fois, sans reconduction automatique</li>
              <li>La livraison au pas de votre porte **</li>
              <li>Valable immédiatement sur votre panier</li>
            </ul>
          </div>
          <div
            v-if="!isAbonneInMagasin && displayMode !== 'appli'"
            class="c-abonnement-lad-fiche__btn-wrapper u-mb-md"
          >
            <Button
              variant="secondary"
              radius="full"
              size="lg25"
              @click="scrollToAbonnements"
            >
              J'en profite
            </Button>
          </div>
          <p class="u-font-13 u-color-text-light u-text-center u-mb-xs">
            * à raison d'une livraison maximum par jour ouvrable et pour un {{ minimumLad ? `minimum d'achat de ${minimumLad} € par commande` : "montant minimum d'achat en fonction de votre magasin" }}, sous réserve d'un créneau de livraison disponible.<br>Le Service permet uniquement la livraison à domicile par Cora en tant que mode de livraison, à l’exclusion de corapro et de tout autre mode de livraison comme la livraison collaborative.
          </p>
          <p class="u-font-13 u-color-text-light u-text-center">
            ** sous réserve d'éligibilté, se référer aux CGV Livraison Cora
          </p>
        </div>
      </div>

      <div class="c-abonnement-lad-fiche__ccm">
        <Titre
          tag="h2"
          variant="primary"
          size="lg"
          class="u-text-center u-mb-xs@md"
        >
          Comment ça marche ?
        </Titre>
        <div class="c-abonnement-lad-fiche__ccm-wrapper">
          <div class="c-abonnement-lad-fiche__ccm-step">
            <div class="c-abonnement-lad-fiche__ccm-step-text">
              <Badge
                size="lg"
                circle
                variant="primary"
                class="u-flex-shrink-none u-mr-sm"
              >
                1
              </Badge>
              <p>Je choisis mon magasin en fonction de mon adresse de livraison</p>
            </div>
            <LazyImage
              :src="livraisonCcmStep1"
              width="288"
              height="180"
              alt=""
              class="u-flex-shrink-none"
            />
          </div>
          <Divider
            size="sm"
            dotted
          />
          <div class="c-abonnement-lad-fiche__ccm-step">
            <div class="c-abonnement-lad-fiche__ccm-step-text">
              <Badge
                size="lg"
                circle
                variant="primary"
                class="u-flex-shrink-none u-mr-sm"
              >
                2
              </Badge>
              <p>Je choisis la durée d'abonnement qui me convient</p>
            </div>
            <LazyImage
              :src="livraisonCcmStep2"
              width="288"
              height="180"
              alt=""
              class="u-flex-shrink-none"
            />
          </div>
          <Divider
            size="sm"
            dotted
          />
          <div class="c-abonnement-lad-fiche__ccm-step">
            <div class="c-abonnement-lad-fiche__ccm-step-text">
              <Badge
                size="lg"
                circle
                variant="primary"
                class="u-flex-shrink-none u-mr-sm"
              >
                3
              </Badge>
              <p>Je fais mes courses sur le site et je bénéficie de mon abonnement</p>
            </div>
            <LazyImage
              :src="livraisonCcmStep3"
              width="288"
              height="180"
              alt=""
              class="u-flex-shrink-none"
            />
          </div>
          <Divider
            size="sm"
            dotted
          />
          <div class="c-abonnement-lad-fiche__ccm-step">
            <div class="c-abonnement-lad-fiche__ccm-step-text">
              <Badge
                size="lg"
                circle
                variant="primary"
                class="u-flex-shrink-none u-mr-sm"
              >
                4
              </Badge>
              <p>
                Je me fais livrer chez moi * <br>
                <span class="u-font-primary u-font-13 u-font-400 u-color-text-light u-mt-xs">* parmi mes 5 adresses pré-définies</span>
              </p>
            </div>
            <LazyImage
              :src="livraisonCcmStep4"
              width="288"
              height="180"
              alt=""
              class="u-flex-shrink-none"
            />
          </div>
          <div
            v-if="!isAbonneInMagasin && displayMode !== 'appli'"
            class="c-abonnement-lad-fiche__btn-wrapper u-pb-xlg20"
          >
            <Button
              variant="secondary"
              radius="full"
              size="lg25"
              @click="scrollToAbonnements"
            >
              J'en profite
            </Button>
          </div>
          <div
            v-if="!isAbonneInMagasin"
            class="u-text-center u-pb-xlg20"
          >
            <LazyImage
              :src="illuAbonnementTransat"
              width="240"
              height="150"
              alt=""
              class="u-flex-item-fluid"
            />
          </div>
        </div>
      </div>
    </div>

    <Popin
      :visible="popinCgvVisible"
      size="lg"
      aria-label="Conditions générales de vente"
      @hidden="setPopinCgvVisible(false)"
    >
      <CmsFetcher link="/legal/informations-juridiques/conditions-generales-de-vente-abonnement-livraison" />
      <div class="u-flex u-flex-justify-center">
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-m-sm"
          @click="setPopinCgvVisible(false)"
        >
          OK
        </Button>
      </div>
    </Popin>

    <Popin
      :visible="popinZoneVisible"
      size="lg"
      aria-label="Zone de livraison"
      @hidden="setPopinZoneVisible(false)"
    >
      <h2 class="u-color-primary u-font-700 u-font-secondary u-font-24 u-text-center u-mb-md">
        Liste des villes livrées par le magasin {{ shopName }}
      </h2>
      <PlanningCommunesSelector
        class="u-pl-lg u-pr-lg u-pb-md"
        @communeSelected="communeSelected"
      />
    </Popin>
    <Popin
      :visible="commune !== null"
      size="lg"
      aria-label="Planning"
      @closed="commune = null;"
    >
      <Planning
        v-if="commune"
        :selectable="false"
        :service-id="serviceLadId"
        :code-postal="commune ? commune.attributes.code_postal : null"
        :code-insee="commune ? commune.attributes.code_insee : null"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/abonnement-lad-fiche.scss";
</style>
